import { Api } from 'models/services/api';
import { ReadOriginalDishCategoriesQuery } from 'models/services/graphql';

import { OriginalDishCategoryCollectionData } from '../collection';

type DataToRead = {
  menuCategoryId: string
  nextToken?: string;
};

const RequestQuery = `
  query ReadOriginalDishCategories($menuCategoryId: ID!, $nextToken: String) {
    ${ReadOriginalDishCategoriesQuery}
  }
`;

type ResponseData = {
  data: {
    readOriginalDishCategories: OriginalDishCategoryCollectionData;
  }
}

class ReadCollectionGql {

  readonly result?: OriginalDishCategoryCollectionData;
  private readonly api: Api<ResponseData>;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToRead): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw new Error('invalid response');
    const result = api.response.data.readOriginalDishCategories;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, result, api });
  }

}

export { ReadCollectionGql };